import { render, staticRenderFns } from "./BuscarProfesional.vue?vue&type=template&id=ffaa18ba&scoped=true"
import script from "./BuscarProfesional.vue?vue&type=script&lang=js"
export * from "./BuscarProfesional.vue?vue&type=script&lang=js"
import style0 from "./BuscarProfesional.vue?vue&type=style&index=0&id=ffaa18ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa18ba",
  null
  
)

export default component.exports